'use strict';

module.exports = [
  '$urlRouterProvider',
  '$stateProvider',
  function ($urlRouterProvider, $stateProvider) {
    /** Configuro gli endpoint **/

    $stateProvider
      .state('index', {
        controller: [
          '$state',
          function ($state) {
            $state.go('situation-record-index');
          },
        ],
      })
      .state('login', {
        url: '/login',
        template: require('../components/login/login.html'),
        controller: 'ngDroCoreLoginCtrl',
        params: {
          redirectUrl: null,
        },
      })
      .state('main', {
        url: '/main',
        template: require('../components/main/main.html'),
        controller: 'ngDroCoreMainCtrl',
      })
      .state('logout', {
        url: '/logout',
        controller: 'ngDroCoreLogoutCtrl',
      });

    $urlRouterProvider.otherwise('/login');
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/configs/StateProvider.js
// module id = 303
// module chunks = 0